/*
Config on tailwind.config.js/

extend:{
  keyframes:{
  logo:{
    '0%': {bottom:"-10px"},
    '50%' : {top:"0"}, 
    '100%': {bottom:"-10px", right:"-10px"},
  }
}

}
*/

interface LoadingProps {
  loading?: boolean
}

const Loading = ({ loading = true }: LoadingProps) => {
  return (
    <div
      className={`flex ${loading ? 'h-screen' : 'h-full'} items-center justify-center`}
    >
      <div className="relative grid h-20 w-20 grid-cols-2 grid-rows-2 gap-3 shadow-inner">
        <div className="h-10 w-10 bg-black text-white"></div>
        <div className="h-10 w-10 bg-black text-white"></div>
        <div className="h-10 w-10 bg-black text-white"></div>
        <div className="h-10 w-10 rounded-full bg-orange-600"></div>
        <div className="absolute h-11 w-11 animate-[logo_1s_linear_infinite_normal] bg-white opacity-40"></div>
      </div>
    </div>
  )
}

export default Loading
